import { TWidget } from 'widgets/Widget';
import { getJSONByUrl } from 'widgets/toolbox/ajax';
interface IPeeriusCallbacks {
    track?: object | string;
}
declare global {
    interface Window {
        PeeriusCallbacks?: IPeeriusCallbacks;
    }
}

/**
 * @param Widget Base widget for extending
 * @returns Optimizely tracking class
 */
function OptimizelyTrackingClassCreator(Widget: TWidget) {
    /**
     * @category widgets
     * @subcategory int_custom_optimizely
     * @class OptimizelyTracking
     * @augments Widget
     * @classdesc Instantiates an Optimizely Tracking widget class
     */
    class OptimizelyTracking extends Widget {
        prefs() {
            return {
                optimizelyTrackingUrl: '',
                ...super.prefs()
            };
        }

        init() {
            super.init();
            this.eventBus().on('checkout.billing.step.submitted', 'trackPage');
        }

        /**
         * Tracks the current page with Optimizely PeeriusCallbacks.
         *
         * Retrieves the optimizelyTrackingJson stored in the widget, containing page information for tracking
         * and assigns it to PeeriusCallbacks.track object.
         */
        trackPage() {
            const trackingUrl = this.prefs().optimizelyTrackingUrl;
            let peeriusSendAjaxUrl = 'rest.pagex?jd=';

            if (!trackingUrl) {
                return;
            }

            getJSONByUrl(trackingUrl).then(response => {
                const Peerius = window.Peerius;
                const { trackingData } = response;
                const trackingJSON = JSON.stringify(trackingData);
                const peeriusCallbacks = window.PeeriusCallbacks || ({} as IPeeriusCallbacks);

                if (!peeriusCallbacks.track) {
                    peeriusCallbacks.track = {
                        lang: trackingData.lang
                    };

                    window.PeeriusCallbacks = peeriusCallbacks;
                }

                if (trackingData && Object.keys(trackingData).length && Peerius) {
                    peeriusSendAjaxUrl += encodeURIComponent(trackingJSON);
                    Peerius.sendAjax(peeriusSendAjaxUrl);
                }
            });
        }
    }

    return OptimizelyTracking;
}

export type TOptimizelyTracking = ReturnType<typeof OptimizelyTrackingClassCreator>;

export type TOptimizelyTrackingInstance = InstanceType<TOptimizelyTracking>;

export default OptimizelyTrackingClassCreator;
